import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  class: "d-sm-flex align-items-center",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-md-2 d-flex align-items-end" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25 w-100" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_14 = {
  key: 0,
  class: "row g-3 mb-25"
}
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = {
  class: "d-flex align-items-center gap-3 border rounded-3 px-15 py-12",
  style: {"background":"#f0f4ff","min-height":"64px"}
}
const _hoisted_17 = {
  class: "d-flex align-items-center justify-content-center rounded-circle flex-shrink-0",
  style: {"width":"40px","height":"40px","background":"#4361ee25"}
}
const _hoisted_18 = {
  class: "fs-18 fw-bold",
  style: {"color":"#4361ee","line-height":"1"}
}
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = {
  class: "d-flex align-items-center gap-3 border rounded-3 px-15 py-12",
  style: {"background":"#f0fff4","min-height":"64px"}
}
const _hoisted_21 = {
  class: "d-flex align-items-center justify-content-center rounded-circle flex-shrink-0",
  style: {"width":"40px","height":"40px","background":"#19875425"}
}
const _hoisted_22 = {
  class: "fs-18 fw-bold",
  style: {"color":"#198754","line-height":"1"}
}
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = {
  class: "d-flex align-items-center gap-3 border rounded-3 px-15 py-12",
  style: {"background":"#fff5f5","min-height":"64px"}
}
const _hoisted_25 = {
  class: "d-flex align-items-center justify-content-center rounded-circle flex-shrink-0",
  style: {"width":"40px","height":"40px","background":"#dc354525"}
}
const _hoisted_26 = {
  class: "fs-18 fw-bold",
  style: {"color":"#dc3545","line-height":"1"}
}
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = {
  class: "d-flex align-items-center gap-3 border rounded-3 px-15 py-12",
  style: {"background":"#f0fbff","min-height":"64px"}
}
const _hoisted_29 = {
  class: "d-flex align-items-center justify-content-center rounded-circle flex-shrink-0",
  style: {"width":"40px","height":"40px","background":"#0dcaf025"}
}
const _hoisted_30 = {
  class: "fs-16 fw-bold",
  style: {"color":"#0a8fa3","line-height":"1.2"}
}
const _hoisted_31 = {
  key: 1,
  class: "text-center py-30"
}
const _hoisted_32 = {
  key: 2,
  class: "text-center py-30 text-muted"
}
const _hoisted_33 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_34 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "shadow-none text-center" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_42 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-end" }
const _hoisted_43 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-end" }
const _hoisted_44 = { class: "shadow-none lh-1 fw-medium text-center" }
const _hoisted_45 = { class: "shadow-none lh-1 fw-medium text-center" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  colspan: "10",
  class: "p-0"
}
const _hoisted_48 = {
  class: "px-25 py-15",
  style: {"background":"#f8f9fa","border-top":"2px solid #e2e8f0"}
}
const _hoisted_49 = {
  class: "fs-13 fw-semibold mb-10",
  style: {"color":"#555"}
}
const _hoisted_50 = {
  class: "table table-sm mb-0",
  style: {"background":"#fff","border":"1px solid #e9ecef","border-radius":"6px","overflow":"hidden"}
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "py-8 px-12 fs-13 fw-medium text-black" }
const _hoisted_53 = { class: "py-8 px-12 fs-13 text-center fw-semibold" }
const _hoisted_54 = { class: "py-8 px-12 fs-13 text-end" }
const _hoisted_55 = { class: "py-8 px-12 fs-13 text-end" }
const _hoisted_56 = { class: "py-8 px-12 fs-13 text-center" }
const _hoisted_57 = {
  key: 0,
  class: "badge bg-warning text-dark"
}
const _hoisted_58 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_59 = { class: "py-8 px-12 fs-13 fw-bold text-end" }
const _hoisted_60 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          ref: "etatForm",
          "validation-schema": _ctx.etatSchema,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date Début", -1)),
                  _createVNode(_component_Field, {
                    name: "dateDebut",
                    type: "date",
                    modelValue: _ctx.dateDebut,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateDebut) = $event)),
                    style: {"background-color":"#fff"},
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateDebut",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date Fin", -1)),
                  _createVNode(_component_Field, {
                    name: "dateFin",
                    type: "date",
                    modelValue: _ctx.dateFin,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateFin) = $event)),
                    style: {"background-color":"#fff"},
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateFin",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Utilisateur", -1)),
                  _createVNode(_component_Field, {
                    name: "selectedUser",
                    modelValue: _ctx.selectedUser,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUser) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        options: _ctx.utilisateursOptions,
                        searchable: true,
                        "no-results-text": "Aucun utilisateur trouvé",
                        placeholder: "Tous les utilisateurs",
                        "can-clear": true
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary w-100",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reinitialiser && _ctx.reinitialiser(...args)))
                  }, " Réinitialiser ")
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_vue_feather, {
                    type: "shopping-bag",
                    size: "18",
                    style: {"color":"#4361ee"}
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", {
                    class: "fs-12 mb-1",
                    style: {"color":"#666"}
                  }, "Total commandes", -1)),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.totalElements), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_vue_feather, {
                    type: "check-circle",
                    size: "18",
                    style: {"color":"#198754"}
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", {
                    class: "fs-12 mb-1",
                    style: {"color":"#666"}
                  }, "Payées", -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.totalPayees), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_vue_feather, {
                    type: "x-circle",
                    size: "18",
                    style: {"color":"#dc3545"}
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", {
                    class: "fs-12 mb-1",
                    style: {"color":"#666"}
                  }, "Annulées", -1)),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.totalAnnulees), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_vue_feather, {
                    type: "dollar-sign",
                    size: "18",
                    style: {"color":"#0a8fa3"}
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", {
                    class: "fs-12 mb-1",
                    style: {"color":"#666"}
                  }, "Montant total (FCFA)", -1)),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatMontant(_ctx.totalMontant)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[11] || (_cache[11] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
            ], -1)
          ])))
        : (_ctx.commandes.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Aucune commande trouvée pour les filtres sélectionnés. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("table", _hoisted_34, [
                _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0",
                      style: {"width":"40px"}
                    }),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, "Réf. Cmd"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, "Date"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, "Utilisateur"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, "Client"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, "Type"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                    }, "Montant HT"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                    }, "Montant TTC"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
                    }, "Statut paie."),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
                    }, "Statut liv.")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commandes, (commande, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: commande.id
                    }, [
                      _createElementVNode("tr", {
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.toggleExpand(commande.id))
                      }, [
                        _createElementVNode("td", _hoisted_36, [
                          _createVNode(_component_vue_feather, {
                            type: _ctx.expandedIds.includes(commande.id) ? 'chevron-down' : 'chevron-right',
                            size: "15",
                            style: {"color":"#888"}
                          }, null, 8, ["type"])
                        ]),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(commande.refCom), 1),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.format_Date(commande.dateCommande)), 1),
                        _createElementVNode("td", _hoisted_39, _toDisplayString(commande.user?.nom) + " " + _toDisplayString(commande.user?.prenom), 1),
                        _createElementVNode("td", _hoisted_40, _toDisplayString(commande.client?.nomClient) + " " + _toDisplayString(commande.client?.prenomClient), 1),
                        _createElementVNode("td", _hoisted_41, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", {
                      'bg-primary': commande.typeCommande === 'Au comptoir',
                      'bg-warning text-dark': commande.typeCommande === 'Sur commande'
                    }])
                          }, _toDisplayString(commande.typeCommande), 3)
                        ]),
                        _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatMontant(commande.montHT)), 1),
                        _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatMontant(commande.montTTC)), 1),
                        _createElementVNode("td", _hoisted_44, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", {
                      'bg-light text-dark': _ctx.getStatutPaiement(commande) === 'En attente',
                      'bg-success':         _ctx.getStatutPaiement(commande) === 'Payée',
                      'bg-info':            _ctx.getStatutPaiement(commande) === 'Partielle',
                      'bg-danger':          _ctx.getStatutPaiement(commande) === 'Annulée'
                    }])
                          }, _toDisplayString(_ctx.getStatutPaiement(commande)), 3)
                        ]),
                        _createElementVNode("td", _hoisted_45, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", {
                      'bg-light text-dark': _ctx.getStatutLiv(commande) === 'Non livrée',
                      'bg-success':         _ctx.getStatutLiv(commande) === 'Livrée',
                      'bg-info':            _ctx.getStatutLiv(commande) === 'Partielle',
                      'bg-danger':          _ctx.getStatutLiv(commande) === 'Annulée'
                    }])
                          }, _toDisplayString(_ctx.getStatutLiv(commande)), 3)
                        ])
                      ], 8, _hoisted_35),
                      (_ctx.expandedIds.includes(commande.id))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                            _createElementVNode("td", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_vue_feather, {
                                    type: "package",
                                    size: "14",
                                    class: "me-5",
                                    style: {"color":"#6c757d"}
                                  }),
                                  _createTextVNode(" Produits — " + _toDisplayString(commande.refCom), 1)
                                ]),
                                _createElementVNode("table", _hoisted_50, [
                                  _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", { style: {"background":"#eef2ff"} }, [
                                      _createElementVNode("th", { class: "fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12" }, "Produit"),
                                      _createElementVNode("th", { class: "fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-center" }, "Qté"),
                                      _createElementVNode("th", { class: "fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-end" }, "Prix HT"),
                                      _createElementVNode("th", { class: "fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-end" }, "Prix TTC"),
                                      _createElementVNode("th", { class: "fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-center" }, "Remise"),
                                      _createElementVNode("th", { class: "fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-end" }, "Montant TTC")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (!commande.proCondiCommandeClients || commande.proCondiCommandeClients.length === 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_51, _cache[12] || (_cache[12] = [
                                          _createElementVNode("td", {
                                            colspan: "6",
                                            class: "text-center text-muted py-10 fs-13"
                                          }, "Aucun produit", -1)
                                        ])))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commande.proCondiCommandeClients, (prod, pIndex) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: pIndex }, [
                                        _createElementVNode("td", _hoisted_52, _toDisplayString(prod.libelleProduit), 1),
                                        _createElementVNode("td", _hoisted_53, _toDisplayString(prod.qtite), 1),
                                        _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.formatMontant(prod.prixHt)), 1),
                                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatMontant(prod.prixTtc)), 1),
                                        _createElementVNode("td", _hoisted_56, [
                                          (prod.remise > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(prod.remise) + "%", 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_58, "—"))
                                        ]),
                                        _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.formatMontant(prod.montantTtc)), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ])),
      _createElementVNode("div", _hoisted_60, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}